import { Injectable } from '@angular/core';
import { catchError, debounceTime, distinctUntilChanged, map, shareReplay, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../services/api.service';
import { Store } from '../store';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';
import { defaultOrderBoardSearchParams } from '../data-types/search-params';

@Injectable({
    providedIn: 'root',
})
export class GlobalSearchService {
    env = environment;
    public _search$ = new BehaviorSubject('');
    public search$ = this._search$.asObservable().pipe(debounceTime(500), distinctUntilChanged());
    public searchStored$ = this.search$.pipe(shareReplay(1));

    constructor(private http: HttpClient, private apiService: ApiService, private store: Store) {}
    get currentSearchTerm(): string {
        return this._search$.value || '';
    }
    fetchResults(keyword: string) {
        return this.http.post(
            this.env.apiPath + 'smart-search',
            { params: { searchText: keyword } },
            this.apiService.getHttpOptions()
        );
    }
    search(keyword: string) {
        this._search$.next(keyword);
    }
    searchAccounts(params: any) {
        return this.http
            .get(
                this.env.apiPath + 'smart-search/accounts' + `?${new URLSearchParams(params as any).toString()}`,
                this.apiService.getHttpOptions()
            )
            .pipe(
                map((data: any) => {
                    return data;
                }, catchError(this.apiService.handleError))
            );
    }
    searchProducts(params: any) {
        return this.http
            .get(
                this.env.apiPath + 'smart-search/products' + `?${new URLSearchParams(params as any).toString()}`,
                this.apiService.getHttpOptions()
            )
            .pipe(
                map((data: any) => {
                    return data;
                }, catchError(this.apiService.handleError))
            );
    }
    searchChats(params: any) {
        const user = this.store.selectForLocal('user');
        return this.http
            .post(
                this.env.apiPath + 'chat-admin/groups/search/smart',
                { params: { searchTerm: params.searchText }, user: user },
                this.apiService.getHttpOptions()
            )
            .pipe(
                map((data: any) => {
                    return data;
                }, catchError(this.apiService.handleError))
            );
    }
}
